import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { StudiComponent } from 'src/app/admin/studi/studi.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => StudioPickerComponent) },
  ],
  selector: 'studio-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class StudioPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(StudiComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
